// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"d85f79ef","171":"008ba785","453":"68d2f560","507":"22aca0ea","889":"b044b8ee","949":"058cfacf"}[chunkId] + ".chunk.js";
};